import type {ToolCallMessagePartStatus} from '@assistant-ui/react';
import React, {useMemo} from 'react';

import {readNoticeContent, writeNoticeContent} from './content';
import {MemoryNotice} from './MemoryNotice';

/**
 * READ_PROJECT_MEMORY_TOOL_NAME and WRITE_PROJECT_MEMORY_TOOL_NAME are the
 * backend tool names for project memory (mirrors `project_memory_tools.py`).
 * The toolkit keys on them and this component branches on them.
 */
export const READ_PROJECT_MEMORY_TOOL_NAME = 'read_project_memory';
export const WRITE_PROJECT_MEMORY_TOOL_NAME = 'write_project_memory';

type ProjectMemoryNoticeProps = {
  toolName: string;
  args: Record<string, unknown>;
  result?: unknown;
  status: ToolCallMessagePartStatus;
  isError?: boolean;
};

/**
 * ProjectMemoryNotice picks the project-scoped wording for one of the two
 * project memory tools and hands it to the shared notice.
 */
export const ProjectMemoryNotice: React.FC<ProjectMemoryNoticeProps> = ({
  toolName,
  args,
  result,
  status,
  isError = false,
}) => {
  const content = useMemo(
    () =>
      toolName === READ_PROJECT_MEMORY_TOOL_NAME
        ? readNoticeContent(args, result, isError)
        : writeNoticeContent(args, result, isError),
    [toolName, args, result, isError]
  );

  return <MemoryNotice content={content} status={status} toolName={toolName} />;
};
